import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ModalSelecionarFiltrosPageRoutingModule } from './modal-selecionar-filtros-routing.module';
import { ModalSelecionarFiltrosPage } from './modal-selecionar-filtros.page';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxMaskModule.forRoot(),
    ModalSelecionarFiltrosPageRoutingModule
  ],
  declarations: [ModalSelecionarFiltrosPage]
})
export class ModalSelecionarFiltrosPageModule {}
